import { Typography } from '@navi/web-ui/lib/primitives';
import NotFoundFolderIcon from '@cp/src/assets/images/icons/NotFoundFolder';
import { useNaviTableContext } from '../../context/NaviTableContext';
import TableLoader from '@cp/src/components/TableLoader/TableLoader';
import NaviTableBodyRow from './NaviTableBodyRow';
import { RowData } from '@tanstack/react-table';

const NaviTableBodyRowWrapper = <TData extends RowData>() => {
  const { table, loading, emptyDataComponent } = useNaviTableContext<TData>();
  const rows = table.getRowModel().rows;

  if (loading) return <TableLoader numberOfLines={10} />;
  if (!rows?.length) {
    if (emptyDataComponent) return <>{emptyDataComponent} </>;
    return (
      <div className="h-[400px] flex flex-col items-center justify-center gap-2">
        <NotFoundFolderIcon />
        <Typography variant="h4" color="var(--navi-color-gray-c3)">
          No data found!
        </Typography>
      </div>
    );
  }

  return (
    <>
      {rows.map(row => (
        <NaviTableBodyRow key={row.id} row={row} />
      ))}
    </>
  );
};

export default NaviTableBodyRowWrapper;
